import React, { useState, useCallback } from 'react';
import Cookie from 'universal-cookie';
import dayjs from 'dayjs';

import {
  COOKIE_PATH,
  COOKIE_DOMAIN,
  COOKIE_CONSENT,
  COOKIE_FUNCTIONAL,
  COOKIE_ANALYTICS,
  COOKIE_ADVERTISING,
} from 'constants/cookies';

import CookieInitialDecision from './CookieInitialDecision';
import CookiePreferences from './CookiePreferences';

const nextYear = (): Date => dayjs().add(1, 'year').toDate();

interface CookiePreferencesData {
  advertising: boolean;
  analytics: boolean;
  functional: boolean;
}

interface CookieConsentProps {
  viewCookiePreferences?: boolean;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ viewCookiePreferences = false }) => {
  const [viewCookieOptions, setViewCookieOptions] = useState<boolean>(viewCookiePreferences);

  const handleUpdatePreferences = useCallback(
    ({ advertising, analytics, functional }: CookiePreferencesData) => {
      const cookies = new Cookie();
      const cookieOptions = {
        expires: nextYear(),
        path: COOKIE_PATH,
        domain: COOKIE_DOMAIN,
      };
      cookies.set(COOKIE_CONSENT, '1', cookieOptions);
      cookies.set(COOKIE_ANALYTICS, analytics ? '1' : '0', cookieOptions);
      cookies.set(COOKIE_ADVERTISING, advertising ? '1' : '0', cookieOptions);
      cookies.set(COOKIE_FUNCTIONAL, functional ? '1' : '0', cookieOptions);

      window.location.reload();
    },
    [],
  );

  const handleAcceptAllCookies = (): void =>
    handleUpdatePreferences({ advertising: true, analytics: true, functional: true });

  const handleRejectAllCookies = (): void =>
    handleUpdatePreferences({ advertising: false, analytics: false, functional: false });

  return !viewCookieOptions ? (
    <CookieInitialDecision
      acceptAll={handleAcceptAllCookies}
      rejectAll={handleRejectAllCookies}
      viewPreferences={() => setViewCookieOptions(true)}
    />
  ) : (
    <CookiePreferences
      // TODO: Bring this prop back if we'd like to handle redirect urls from the query string
      // returnUrl={returnUrl}
      updatePreferences={handleUpdatePreferences}
    />
  );
};
